import { env } from '@/env';
import { useLogtoRoles } from '@/hooks/useLogtoRoles';
import { hasAnyRole } from '@/lib/roleRevalidation';

/**
 * Chi puo' CREARE o SPENDERE sugli avatar (I-416, L-2762): gli ingressi alla creazione si chiudono a chi non ha NESSUNO dei ruoli creatore
 * (`env.avatarCreatorRoles`: `administrator` e, su staging, `avatar_creator_collaudo`) **solo dove il flag di solo staging
 * `VITE_FEATURE_AVATAR_STUDIO_ENABLED` e' acceso** (I-270: nessun comportamento nuovo in produzione senza un GO a parte).
 *
 * - flag SPENTO (produzione, prodtenant): `true` per tutti — gli ingressi sono quelli di oggi, qualunque cosa dica `VITE_AVATAR_CREATOR_ROLES`.
 * - flag ACCESO (staging): `true` per chi ha ALMENO UNO dei ruoli creatore.
 *
 * ⚠️ I ruoli si leggono UNA volta (`useLogtoRoles`) e si intersecano: niente `useHasLogtoRole` in un ciclo di lunghezza variabile.
 * E la lettura sta SEMPRE prima del flag: una chiamata condizionale cambierebbe l'ordine degli hook fra un build e l'altro.
 */
export function usePuoCreareAvatar(): boolean {
  const ruoli = useLogtoRoles();
  return !env.featureAvatarStudioEnabled || hasAnyRole(ruoli, env.avatarCreatorRoles);
}
